import { render, staticRenderFns } from "./formTemplates.vue?vue&type=template&id=c8d1f1ec&scoped=true"
import script from "./formTemplates.vue?vue&type=script&lang=js"
export * from "./formTemplates.vue?vue&type=script&lang=js"
import style0 from "./formTemplates.vue?vue&type=style&index=0&id=c8d1f1ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1f1ec",
  null
  
)

export default component.exports